var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "800" } },
    [
      _c("w-card-title", [
        _vm._v("Subscription " + _vm._s(_vm.sub.id) + " bewerken"),
      ]),
      _vm.tab == 0
        ? _c("app-company-subscription-edit-form", {
            attrs: { sub: _vm.sub },
            on: {
              raw: function ($event) {
                _vm.tab = 1
              },
            },
          })
        : _vm.tab == 1
        ? _c("app-company-subscription-edit-raw", {
            attrs: { sub: _vm.sub },
            on: {
              back: function ($event) {
                _vm.tab = 0
              },
            },
          })
        : _vm._e(),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("Annuleren")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }